<template>
  <button
    type="button"
    class="btn bg-primary text-white rounded rounded-5 px-5"
    @click="showComingSoon"
  >
    {{ label ?? t("common.buttons.get-started") }}
  </button>
</template>

<script setup lang="ts">
import { ThemedSwal } from "@/constants/themed-swal";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// eslint-disable-next-line no-undef
defineProps<{
  label?: string;
}>();

const showComingSoon = () => {
  ThemedSwal.fire({
    title: t("swals.app-coming-soon.title"),
    text: t("swals.app-coming-soon.description"),
    icon: "info",
    confirmButtonText: t("swals.app-coming-soon.confirm"),
  });
};
</script>

<style scoped></style>
